var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slider-container position-relative"},[_c('div',{staticClass:"member-slider"},_vm._l((_vm.slides),function(slide,index){return _c('member-slide',{key:index,attrs:{"slide":slide,"button-text":_vm.translations.sliderButton}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }